export const playClick = () => {
  const audio = new Audio('/click.mp3'); // you must include click.mp3 in /public
  audio.play();
};